export const RouteRoot = "/";
export const RouteDashboard = "/dashboard";
export const RouteTarefas = "/tarefas";
export const RouteOrcamentos = "/orcamentos";
export const RouteLogin = "/login";
export const RouteUsuarios = "/usuarios";